// src/components/instructor/ops/UnassignedQueue.js
//
// Pass 49B §15 — focused operations queue of selected-season bookings with no canonical
// assigned instructor. The 8 Sam workbook bookings show UNASSIGNED and preserve their
// sourceInstructorLabel ("Instructor 1"/"Instructor 2") as provenance ONLY — never auto-mapped.
// Assignment (current season) goes through the capability-gated AssignControl.

import React from 'react';
import { ActivityBadge, PaymentBadge, fmtTime } from './opsShared';
import AssignControl from './AssignControl';

export default function UnassignedQueue({ queue = [], seasonMembers = [], seasonId, organization = null, readOnly = false, onChanged, onOpenBooking, highlightBookingId = '' }) {
  if (!queue.length) {
    return <div data-testid="unassigned-empty" style={{ padding: 24, textAlign: 'center', color: '#9E9B95', fontSize: 13 }}>No unassigned bookings this season.</div>;
  }
  const row = { display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderBottom: '1px solid #ECEAE6', flexWrap: 'wrap' };

  return (
    <div data-testid="unassigned-queue">
      <div style={{ fontSize: 11, color: '#92400E', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.4, padding: '8px 12px' }}>
        {queue.length} unassigned
      </div>
      {queue.map((item) => {
        const b = item.booking;
        const highlighted = highlightBookingId && b.id === highlightBookingId;
        return (
          <div key={item.id} ref={highlighted ? (el) => el && el.scrollIntoView({ block: 'center' }) : null}
            style={{ ...row, ...(highlighted ? { background: '#FFFBEB', outline: '2px solid #C97D10', outlineOffset: -2 } : {}) }}
            data-testid={`unassigned-${item.id}`} data-highlighted={highlighted ? 'true' : undefined}>
            <span style={{ padding: '2px 8px', borderRadius: 999, background: '#FEF3C7', color: '#92400E', fontSize: 10.5, fontWeight: 700 }}>UNASSIGNED</span>
            <span style={{ fontSize: 11, fontFamily: "'DM Mono',monospace", color: '#6B6860', minWidth: 92 }}>
              {item.serviceDate || (b.startAt ? fmtTime(b.startAt) : '—')}
            </span>
            <ActivityBadge booking={b} />
            {item.requesterName ? <span style={{ fontSize: 12.5, color: '#1A1917' }}>{item.requesterName}</span> : null}
            {item.sourceInstructorLabel
              ? <span data-testid="source-label" style={{ fontSize: 11, color: '#92400E', fontStyle: 'italic' }}>source: {item.sourceInstructorLabel}</span>
              : null}
            <PaymentBadge booking={b} />
            <span style={{ marginLeft: 'auto', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
              {onOpenBooking && (
                <button type="button" data-testid={`unassigned-detail-${item.id}`} onClick={() => onOpenBooking(b)}
                  style={{ fontSize: 11, padding: '3px 8px', borderRadius: 6, border: '1px solid #ECEAE6', background: '#fff', cursor: 'pointer', color: '#57534E' }}>Details</button>
              )}
              <AssignControl booking={b} seasonMembers={seasonMembers} seasonId={seasonId} organization={organization} readOnly={readOnly} onAssigned={onChanged} />
            </span>
          </div>
        );
      })}
    </div>
  );
}
